<template>
  <div class="results-container">
    <div class="counts">
      <div class="box">
        
        <div class="columns">
          <div class="column is-half">
              <p class="heading has-text-centered">
                Universe
              </p>
              <p class="has-text-centered">
                <strong>{{ universe.name }}</strong> 
              </p>
              <EditUniverseButton/>
          </div><!-- half column -->
          <div class="columns is-half">
            <div class="results-buttons has-text-centered" v-if="!$root.iframed">
              <template v-if="companies.a.length > 0">
                <button v-show="activeScreens.length > 0" v-on:click="toggleTablePane('flagged')" class="button is-small is-info is-rounded">
                  Flagged Companies >
                </button>
                <!-- <button v-show="activeScreens.length > 0" v-on:click="toggleTablePane('heatmap')" class="button is-small is-primary is-rounded">
                  Heatmap Table >
                </button> -->
                <div
                  v-show="!isLoading && activeScreens.length > 0"
                >
                  <b-dropdown
                    v-bind:triggers="['hover']"
                    position="is-bottom-left"
                    aria-role="list"
                  >
                    <template #trigger>
                      <b-button
                        label="Download"
                        type="is-light"
                        class="is-rounded"
                        size="is-small"
                        icon-pack="fas"
                        icon-right="caret-down"
                      />
                    </template>
                    <b-dropdown-item has-link aria-role="listitem" class="has-text-right">
                      <a
                        v-bind:href="downloadTable()"
                        download="export.csv"
                      >
                        Download Flags
                      </a>
                    </b-dropdown-item>
                    <b-dropdown-item has-link aria-role="listitem" class="has-text-right" v-if="$root.advisor.hasFeature('Percentile Download')">
                      <a
                        v-bind:href="downloadTable({percentiles: true})"
                        download="export.csv"
                      >
                        Download Flags & Percentiles
                      </a>
                    </b-dropdown-item>
                    <b-dropdown-item has-link aria-role="listitem" class="has-text-right" v-if="$root.advisor.hasFeature('Download Across All Universes')">
                      <a
                        @click="downloadUniverse()"
                      >
                        Download Across All Universes
                      </a>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </template>
            </div>
          </div><!-- half column -->
        </div><!-- coulmsn -->
        
        <template v-if="companies.loaded && companies.a.length > 0">
          <nav class="level is-mobile">
            <div class="level-item">
              <div>
                <p class="heading">Universe</p>
                <p class="title is-5" id="universe-length">{{ companies.a.length }}</p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Exclusion Flags</p>
                <p class="title is-5">{{ isLoading ? 'Calculating...' : excludedCount }}</p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Inclusion Flags</p>
                <p class="title is-5">{{ isLoading ? 'Calculating...' : includedCount }}</p>
              </div>
            </div>
          </nav>
        </template>
        <template v-if="!companies.loaded">
          <b-progress type="is-success" size="is-small" v-bind:value="percentLoaded" show-value>
            Loading Company Metric Data... {{ percentLoaded }}%
          </b-progress>
        </template>
        <template v-if="companies.loaded && companies.a.length === 0">
          <p class="notification is-warning is-light">
            No companies were found in this universe, please check if it contains only funds.
          </p>
        </template>
        <div>
          <Optimizer
            v-if="$root.advisor.hasFeature('Optimizer') && !$root.advisor.hasFeature('Company Screener Bonds') "
            :universe="universe"
            :screens="activeScreens"
            :flaggedTable="flaggedTable"
            :portfolio="portfolio"
            :isLoading="isLoading"
          />
        </div>
        <div v-show="$root.advisor.hasFeature('Orion Eclipse Exclusions') && !isLoading && activeScreens.length > 0 && !$root.iframed">
          <hr />
          <br>
          <div class="buttons is-centered">
            <b-button v-on:click="showEclipseModal">
              Send to Orion Eclipse
            </b-button>
            <AstroProspectButton
              v-show="$root.advisor.hasFeature('Orion Prospect Creation') && prospectId"
              :prospect_external_id="prospectId"
              :holdings="constrainedHoldingsForAstro"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-bind:class="['all-table', {visible: showTablePane}]">
      <button v-on:click="toggleTablePane" class="button is-medium is-rounded">Close</button>
      <button 
        v-on:click="() => { showingPortfolioSideBar = !showingPortfolioSideBar }"
        class="button is-small is-primary is-pulled-right"
        v-if="false && this.$root.advisor.hasFeature('Company Screener Portfolio Editor')"
      >
        Toggle Portfolio Editor
      </button>


      <div class="table-container" v-if="showTablePane && flaggedTable && flaggedTable.columns && tableType == 'flagged'">
        <div class="columns">
          <div v-bind:class="['column', portfolioEditorEnabled ? 'is-8' : 'is-12']">
            <b-table
                v-bind:data="flaggedTable.data"
                v-bind:loading="isLoading"
                sticky-header
                icon-pack="fas"
                ref="table"
            >

              <b-table-column field='name' label='Company' sortable searchable v-slot="props">
                {{ props.row.name }}
              </b-table-column>

              <b-table-column field='symbol' label='Primary Symbol' sortable searchable v-slot="props">
                {{ props.row.symbol }}
              </b-table-column>
              <b-table-column field='securitySymbol' label='Security Symbol' sortable searchable v-slot="props">
                {{ props.row.securitySymbol }}
              </b-table-column>


              <b-table-column field='sector' label='Sector' sortable searchable v-bind:visible="portfolioEditorEnabled">
                <template
                    slot="searchable"
                    slot-scope="props">
                    <b-input
                      v-model="props.filters[props.column.field]"
                      placeholder=""
                      size="is-small"
                    />
                </template>

                <template v-slot="props">
                  {{ props.row.sector }}
                </template>
              </b-table-column>
              <b-table-column field='ticker_sector' label='Sector' sortable searchable v-bind:visible="!portfolioEditorEnabled">
                <template
                    slot="searchable"
                    slot-scope="props">
                    <b-input
                      v-model="props.filters[props.column.field]"
                      placeholder=""
                      size="is-small"
                    />
                </template>

                <template v-slot="props">
                  {{ props.row.ticker_sector }}
                </template>
              </b-table-column>

              <b-table-column field='market_cap' label='Market Cap' sortable v-slot="props" v-bind:visible="portfolioEditorEnabled">
                {{ props.row.market_cap ? bigDollarFormat(props.row.market_cap) : '' }}
              </b-table-column>

              <b-table-column field='flagged_total' label='Number of Screens Flagged for Exclusion' sortable v-slot="props">
                {{ props.row.flagged_total }}
              </b-table-column>
              <b-table-column field='included_total' label='Number of Screens Flagged for Inclusion' sortable v-slot="props">
                {{ props.row.included_total }}
              </b-table-column>


              <b-table-column
                field='avg_percentile'
                label='Average Percentile'
                sortable v-slot="props"
              >
                {{ props.row.num_percentiles > 0 ? preciseRound(props.row.avg_percentile * 100, 0) : '' }}
              </b-table-column>

              <b-table-column
                v-for="(col, idx) in flaggedTable.columns"
                v-bind:field="`metric_${col.metricId}_percentile`"
                v-bind:label="col.label"
                sortable
              >
                <template slot="subheading" slot-scope="props">
                  {{ col.subheading }}
                </template>
                <template v-slot="props">
                  <span
                    v-if="props.row[`metric_${col.metricId}_percentile`] != null"
                    v-bind:class="[props.row[col.field] ? `cell-flagged-for-${props.row[col.field]}` : '']"
                  >
                    {{ preciseRound(props.row[`metric_${col.metricId}_percentile`] * 100, 1) }}
                  </span>
                </template>
              </b-table-column>

              <b-table-column
                v-bind:visible="exchanging !== null"
              >
                <template v-slot="props">
                  <b-tooltip
                    v-if="exchanging !== null"
                    type="is-white"
                    multilined
                    size="is-xxlarge"
                    position="is-left"
                  >
                    <template v-slot:content>
                      <div class="exchange-comparison">
                        <div class="columns">
                          <div
                            class="column is-half"
                          >
                            <p>
                              <em>Potential Replacement</em>
                              <br>
                              <strong>{{ props.row.symbol }}</strong>
                            </p>
                            <p class="fund-name">{{ props.row.name }}</p>
                            <table>
                              <tr v-for="v in activeScreens">
                                <td>{{ v.name }}</td>
                                <td v-bind:class="[props.row[`metric_${v.id}_flagged`] ? 'cell-flagged-for-exclusion' : '', props.row[`metric_${v.id}_inclusion`] ? 'cell-flagged-for-inclusion' : '']">
                                  <template v-if="props.row[`metric_${v.id}_percentile`] !== null">
                                    {{ (props.row[`metric_${v.id}_percentile`] * 100).toFixed(0) }}
                                  </template>
                                </td>
                              </tr>

                              <tr>
                                <td>Sector</td>
                                <td>
                                  {{ props.row.sector }}
                                </td>
                              </tr>

                            </table>
                          </div>
                          <div
                            class="column is-half"
                          >
                            <p>
                              <em>Currently in Portfolio</em>
                              <br>
                              <strong>{{ exchanging.holding.symbol }}</strong>
                            </p>
                            <p class="fund-name">{{ exchanging.holding.full_name }}</p>
                            <table>
                              <tr v-for="v in activeScreens">
                                <td>{{ v.name }}</td>
                                <td v-bind:class="[exchanging.metrics[`metric_${v.id}_flagged`] ? 'cell-flagged-for-exclusion' : '', exchanging.metrics[`metric_${v.id}_inclusion`] ? 'cell-flagged-for-inclusion': '']">
                                  <template v-if="exchanging.metrics[`metric_${v.id}_percentile`] !== null">
                                    {{ (exchanging.metrics[`metric_${v.id}_percentile`] * 100).toFixed(0) }}
                                  </template>
                                </td>
                              </tr>
                              <tr>
                                <td>Sector</td>
                                <td>
                                  {{ exchanging.holding.company_sector }}
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </div>
                    </template>

                    <b-icon
                      pack="fas"
                      icon="arrow-right"
                      v-on:click.native="exchangeHolding(props.row)"
                    />
                  </b-tooltip>
                </template>
              </b-table-column>

            </b-table>
          </div>
          <div class="column is-4" v-show="portfolioEditorEnabled">
            <WorkingPortfolio
              companies
              v-bind:screens="screens"
              v-bind:chartValueRange="[0, 100]"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';

  import chroma from 'chroma-js';
  import papa from 'papaparse';

  import EditUniverseButton from './EditUniverseButton.vue';
  import Optimizer from './Optimizer.vue';
  import EclipseExclusions from '@frontend/dash3/js/components/integrations/orion/EclipseExclusions.vue';
  import WorkingPortfolio from '@frontend/dash3/js/components/fundscreener/WorkingPortfolio.vue';
  import AstroProspectButton from '@frontend/dash3/js/components/orion/astro/AstroProspectButton.vue';

  import eventBus from '@frontend/shared/EventBus.js';
  import {preciseRound} from '@frontend/shared/Util.js';
  import {bigDollarFormat} from '@frontend/shared/Text.js';
  import telemetry from '@frontend/api/Telemetry.js';
  import gql from 'graphql-tag';


  export default {
    data() {
      return {
        showTablePane: false,
        tableType: 'flagged',
        flaggedTable: {data: [], cols: []},
        results: null,
        excludedCount: 0,
        includedCount: 0,
        recentChange: null,
        downloadPercentiles: false,
        exchanging: null,

        sectorSearch: '',
        showingPortfolioSideBar: false,

        accountValue: 1000000,
        prospectId: '',
      }
    },
    components: {
      EditUniverseButton,
      WorkingPortfolio,
      Optimizer,
      AstroProspectButton,
    },
    props: {
      companies: Object,
      screens: Object,
      universe: Object,
      portfolio: Object
    },
    computed: {
      isLoading: function() {
        return(!this.companies.loaded || !this.screens.loaded)
      },
      portfolioEditorEnabled: function() {
        return this.showingPortfolioSideBar && this.$root.advisor.hasFeature('Company Screener Portfolio Editor');
      },
      orionProductIdEnabled: function() {
        return this.$root.advisor.hasFeature('Orion Prospect Creation')
      },
      activeScreens: function() {
        return this.screens.a.filter((itm) => { return itm.userPercentile > 0; });
      },
      averageColorScale: function() {
        let sum = this.activeScreens.reduce((acc, i) => {return acc + i.userPercentile / 100}, 0);
        let avg = sum / this.activeScreens.length;
        return chroma.scale(['red', 'white', 'green']).domain([0, avg, 1]);
      },
      percentLoaded: function() {
        if (!this.companies.a || this.companies.a.length == 0) {
          return 0;
        }
        return Math.round(100 * (this.companies.a.length / this.companies.total));
      },
      resultingCount: function() {
        return this.companies.a.length - this.excludedCount;
      },
      constrainedHoldingsForAstro: function() {
        const now = new Date().toISOString().split('T')[0];
        const unflaggedHoldings = this.flaggedTable.data
          .filter((i) => {
            return i.flagged_total === 0
          });
        const magicPrice = Math.round(this.accountValue / unflaggedHoldings.length / 10);
        return unflaggedHoldings.map((i) => {
          return {
            ticker: i.symbol,
            shares: 10,
            price: magicPrice,
            purchase_price: magicPrice,
            purchase_date: now,
            face_value: magicPrice,
          }
        });
      }
    },
    methods: {
      bigDollarFormat: bigDollarFormat,
      preciseRound: preciseRound,
      exchangeHolding: function(row) {
        this.exchanging = null;
        Vue.set(this.$refs.table.filters, 'sector', '');
        eventBus.$emit('CompanyScreener:add-holding-to-portfolio', [row], 'exchange');
      },
      calculate: function() {
        if (!this.companies.loaded || !this.screens.loaded) {
          return {
            data: [], cols: []
          }
        }
        let excludedCount = 0
        let includedCount  = 0
        let ret = this.companies.a.map((company)=> {
          let res = {}
          let percentiles = []
          let inclusions = 0
          let exclusions = 0
          let itm = {}

          this.activeScreens.map((screen)=> {
            if(screen.userPercentile != 0) {
              res[screen.id] = 0
              if(screen.id in company.metrics.byId) {
                const metric = company.metrics.byId[screen.id]  
                itm['metric_' + metric.metric_description_id + '_percentile'] = metric.percentile
                percentiles.push(metric.percentile)
                
                if(metric.screen.is_inclusionary) {
                  if(metric.screen.userPercentile > 0 && metric.screen.userPercentile/100.0 <= metric.percentile) {
                    res[metric.metric_description_id] = 1
                    itm['metric_' + metric.metric_description_id + '_inclusion'] = true
                    itm['metric_' + metric.metric_description_id] = 'inclusion'
                    inclusions += 1
                  } else {
                    itm['metric_' + metric.metric_description_id + '_inclusion'] = false
                  }
                } else {
                  if(metric.screen.userPercentile/100.0 > metric.percentile) {
                    res[metric.metric_description_id] = 1
                    itm['metric_' + metric.metric_description_id + '_flagged'] = true
                    itm['metric_' + metric.metric_description_id] = 'exclusion'
                    exclusions += 1
                  } else {
                    itm['metric_' + metric.metric_description_id + '_flagged'] = false
                  }
                }
              }
              else {
                itm['metric_' + screen.id + '_percentile'] = null
                if(screen.is_inclusionary) {
                  itm['metric_' + screen.id + '_inclusion'] = false
                } else {
                  itm['metric_' + screen.id + '_flagged'] = false
                }
              }
            }
          })
          if (inclusions > 0) {
            includedCount += 1
          }
          if (exclusions > 0) {
            excludedCount += 1
          }
          let items = []
          if(company.tickers) {
            company.tickers.forEach((ticker) => {
              items.push({...itm,name:company.name,
                        company_id:company.pk, 
                    avg_percentile:percentiles.reduce((acc, val) => { return acc + val; }, 0) / (percentiles.length > 0 ? percentiles.length : 1) ,
                    num_percentiles:percentiles.length,
                    market_cap: company.marketCap,
                    sector: company.sector,
                    flagged_total: exclusions,
                    included_total: inclusions,
                    symbol: company.primaryIdentifier.symbol,
                    securitySymbol: ticker.symbol,
                    isin: ticker.isin,
                    ticker_sector: ticker.sector,
                    product_id: ticker.orionProductId})
              })
          } else {
            items.push({...itm,name:company.name,
                      company_id:company.pk, 
                  avg_percentile:percentiles.reduce((acc, val) => { return acc + val; }, 0) / (percentiles.length > 0 ? percentiles.length : 1) ,
                  num_percentiles:percentiles.length,
                  market_cap: company.marketCap,
                  sector: company.sector,
                  flagged_total: exclusions,
                  included_total: inclusions,
                  symbol: company.primaryIdentifier.symbol,
                  securitySymbol: company.primaryIdentifier.symbol,
                  isin: company.primaryIdentifier.isin,
                  ticker_sector: company.primaryIdentifier.sector,
                  product_id: company.primaryIdentifier.orionProductId})
          }

          return({'columns':res,'data':items})
        }).reduce((a,b)=> {
         
          Object.keys(b['columns']).forEach((key)=> {
            if(b['columns'][key] > 0 ) {
              a['columns'][key] = (a['columns'][key] || 0 ) + b['columns'][key]
            }
          })

          b['data'].forEach((data) => {
            a['data'].push(data)
          })
          return(a)
        }, {'columns':{},'data':[]})
        ret['columns'] = Object.keys(ret['columns']).map((metricId)=> {
          let val = ret['columns'][metricId]
          let metric = this.screens.byId[metricId]
          let key = 'metric_' + metricId
 
          return {field: key, label:metric.name, metricId, sortable:true, subheading: `${val} companies flagged for ${this.screens.byId[metricId].is_inclusionary ? 'inclusion' : 'exclusion'}` }
          
        })
        this.includedCount = includedCount
        this.excludedCount = excludedCount
        this.flaggedTable = ret
      },
      downloadTable: function(args) {
        // TODO: Most of this is gross and duplicated from the table itself,
        // there is probably a better way to do this with an intermediary.
        // Maybe just generate the "nice" csv version and then the table from
        // that?

        if (!this.companies.loaded) {
          return
        }

        let results = []
        this.flaggedTable.data.forEach((itm) => {
          // If this is a portfolio we need to show all originally present tickers, but if it's a
          // fund we can just default to showing the 'primary' as defined by the API sorting.
          let ticker = 0;
          //let associatedTicker = this.companies.byId[itm.company_id].ticker_set.filter((i) => { return i.symbol === itm.primary_ticker});
          let row = {
            "Company Name": itm.name,
            "Security Symbol": itm.securitySymbol,
            "Primary Symbol": itm.symbol,
            'Sector': itm.ticker_sector,
            "Market Cap (updated monthly)": itm.market_cap,
            "Average Percentile (Among Selected Screens)": Math.round(itm.avg_percentile * 100),
            "Exclusions": itm.flagged_total * -1,
            "Inclusions": itm.included_total,
          }
          if(this.$root.advisor.firm.preferences.show_equity_isin) {
            row["ISIN"] = itm.isin;
          }
          if(this.orionProductIdEnabled) {
            row['Orion Product ID'] = itm.product_id;
          }
          for (let i in itm) {
            if (i.indexOf('metric_') === 0) {
              const baseMetricName = i.replace('metric_', '');
              const screenId = baseMetricName.replace('_flagged', '').replace('_inclusion', '').replace('_percentile', '');
              const screenName = this.screens.byId[+screenId].name;

              if (i.indexOf('_flagged') !== -1) {
                const percentileKey = `metric_${screenId}_percentile`;
                const hasData = percentileKey in itm && itm[percentileKey] !== null;
                
                if (itm[i]) {
                  row['Exclude for ' + screenName] = '-1';
                } else if (hasData) {
                  row['Exclude for ' + screenName] = 'pass';
                } else {
                  row['Exclude for ' + screenName] = '';
                }
              }

              if (i.indexOf('_inclusion') !== -1) {
                row['Include for ' + screenName] = itm[i] ? '1' : '';
              }

              if (args && args.percentiles && i.indexOf('_percentile') !== -1) {
                row[screenName + ' Percentile'] = itm[i] === null ? '' : Math.round(itm[i] * 100);
              }
            }
          }
          if (results.length === 0) {
            // Insert a couple of subhead rows with metadata about the results.
            // Cumbersome to reference the column headers from the flagged table in the export so this is pretty hacky,
            // this whole csv export process needs to be rewritten/implemented on the backend anyhow.
            let colsByMetricName = this.flaggedTable.columns.reduce((acc, itm) => {
              acc[itm.label] = itm;
              return acc;
            }, {});
            let firstSubhead = {};
            for (let key of Object.keys(row)) {
              let metricName = key.replace('Exclude for ', '').replace('Include for', '').replace(' Percentile', '');
              firstSubhead[key] = metricName in colsByMetricName ? `Set percentile: ${this.screens.byId[+colsByMetricName[metricName].metricId].userPercentile}%` : '';
            }
            let secondSubhead = {};
            for (let key of Object.keys(row)) {
              let metricName = key.replace('Exclude for ', '').replace('Include for', '').replace(' Percentile', '');
              secondSubhead[key] = metricName in colsByMetricName ? colsByMetricName[metricName].subheading : '';
            }
            results.push(firstSubhead, secondSubhead);
          }

          results.push(row)
        });
        let csvFile = papa.unparse(results);
        csvFile = `"
          Copyright Stake PBC. All rights reserved. You may not use the information contained herein as the basis for any derivative product 
          (including, without limitation, constructing, modifying, or maintaining any index or passively managed investment products) 
          without the express written consent of Stake PBC.
          The information, data, analyses and opinions contained herein
          (1) include the proprietary information of Stake PBC, or third party content providers
          (2) may not be copied or redistributed, (3) do not constitute investment advice offered by Stake PBC
          (4) are provided solely for informational purposes
          (5) are not warranted to be timely, complete or accurate. Except to the extent otherwise specifically
              required by law, neither Stake PBC, nor its affiliates nor their third party content providers shall
              be responsible for any trading decisions, damages or other losses resulting from, or related to, this
              information, data, analyses, opinions or their use.
        "\n\n` + csvFile

        telemetry.track('Downloaded Export', { type: 'results' });
        return `data:text/csv;charset=utf-8,${encodeURIComponent(csvFile)}`;
      },
      downloadUniverse: function() {
        if (this.downloaded && this.isDownloading) {
          return;
        }
        this.downloaded = true;
        this.isDownloading = true;
        let query = gql`
          query metricData($metricDescription: [ID]) {
            metrics(
              metricDescription_Id_In: $metricDescription
              ticker_AssetType: "0"
              number_Gt: 0
            ) {
              edges {
                node {
                  name
                  number
                  specificWhy
                  company {
                    name
                    primaryIdentifier {
                      symbol
                    }
                    tickerSet(assetType_In: "0") {
                      edges {
                        node {
                          symbol
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        `;
        this.$apollo.query({ query, variables: { metricDescription: this.activeScreens.map((screen) => screen.pk.toString()) } })
        .then((response) => {
          let companies = {}
          let allMetrics= new Set()
          response.data.metrics.edges.forEach((edge) => {
          if(!(edge.node.company.primaryIdentifier.symbol in companies)) {
            companies[edge.node.company.primaryIdentifier.symbol] = {
              'name':edge.node.company.name,
              'primaryIdentifier':edge.node.company.primaryIdentifier.symbol,
              'specificWhy':edge.node.specificWhy,
              'tickers':edge.node.company.tickerSet.edges.map((edge2) => {
                return edge2.node.symbol
              }),
              'metrics':{}
            }
          }
          allMetrics.add(edge.node.name)
          companies[edge.node.company.primaryIdentifier.symbol]['metrics'][edge.node.name] = {'number':edge.node.number,'specificWhy':edge.node.specificWhy}
          })
          let csvFile = papa.unparse(Object.keys(companies).map((key) => { 
            const company = companies[key]
            let row = {'Company Name':company.name,
                'Primary Symbol':company.primaryIdentifier,
                'Symbol List':company.tickers.join(';')}
            allMetrics.forEach((metric) => {
                if(metric in company.metrics) {
                  row[metric] = company.metrics[metric].number
                  row[metric + ' Specific Why'] = company.metrics[metric].specificWhy
                } else {
                  row[metric] = ''
                  row[metric + ' Specific Why'] = ''
                }
              })
            return row
          }))

          csvFile = `"
            Copyright Stake PBC. All rights reserved. You may not use the information contained herein as the basis for any derivative product
            (including, without limitation, constructing, modifying, or maintaining any index or passively managed investment products)
            without the express written consent of Stake PBC.
            The information, data, analyses and opinions contained herein
            (1) include the proprietary information of Stake PBC, or third party content providers
            (2) may not be copied or redistributed, (3) do not constitute investment advice offered by Stake PBC
            (4) are provided solely for informational purposes
            (5) are not warranted to be timely, complete or accurate. Except to the extent otherwise specifically
                required by law, neither Stake PBC, nor its affiliates nor their third party content providers shall
                be responsible for any trading decisions, damages or other losses resulting from, or related to, this
                information, data, analyses, opinions or their use.
          "\n\n` + csvFile;

          var csvData = new Blob([csvFile], {type: 'text/csv;charset=utf-8;'});
          var ourUrl =  null;
          if (navigator.msSaveBlob)
          {
              ourUrl = navigator.msSaveBlob(csvData, 'metric.csv');
          }
          else
          {
              ourUrl = window.URL.createObjectURL(csvData);
          }

          var tLink = document.createElement('a');
          tLink.href = ourUrl;
          tLink.setAttribute('download', 'metric.csv');
          this.isDownloading = false
          tLink.click();       
        })
   
      },
      showEclipseModal: function() {
        this.$buefy.modal.open({
          parent: this,
          component: EclipseExclusions,
          props: {
            exclusionSymbols: this.flaggedTable.data
              .filter((itm) => { return itm.flagged_total > 0 })
              .map((itm) => { return itm.symbol }),
            inclusionSymbols: this.flaggedTable.data
              .filter((itm) => { return itm.included_total > 0 && itm.flagged_total === 0 })
              .map((itm) => { return itm.symbol }),
          },
          hasModalCard: true,
          trapFocus: true,
          canCancel: true,
        });
      },
      flaggedCountForColumn: function() {
      },
      toggleTablePane: function(type) {
        this.tableType = type;
        this.showTablePane = !this.showTablePane;
        document.body.style.overflow = document.body.style.overflow === 'hidden' ? 'scroll' : 'hidden';
        document.body.style.height = document.body.style.height ? null : '100vh';
        if (type == 'flagged') {
          telemetry.track('Viewed Results', {'Viewed Results':'yes'});
        }
      },
    },
    mounted: async function() {
      var self = this;

      eventBus.$on('screens-changed', (screen) => {
        //this.isLoading = true;
        window.clearTimeout(self.recentChange);
        self.recentChange = window.setTimeout(() => {
          self.calculate();
          self.recentChange = null;
        }, 750);
      });
      this.$root.$on('universe-changed', () => {
        this.calculate();
      });
      this.$root.$on('universe-loaded', () => {
        window.clearTimeout(self.recentChange);
        self.recentChange = window.setTimeout(() => {
          this.calculate();
          self.recentChange = null;
        }, 250);
      });


      eventBus.$on('CompanyScreener:exchange-holding', (holding) => {
        this.exchanging = holding;
        if (holding) {
          Vue.set(this.$refs.table.filters, 'sector', holding.holding.company_sector);
        }
      });

    },
  }
</script>

<style lang="scss">
#mainApp {
  padding: 1.5rem;
}

.counts {
  background-color: #fff;
}
.counts {
  grid-row: 1;
  grid-column: 2;
  width: 100%;
  background-color: #fff;
}
.counts .box {
  background: rgba(248, 255, 122, 0.0);
  transition: background 500ms;
}
.loading {
  width: 400px;
  margin: 150px auto;
}
.all-table {
  z-index: 35;
  position: fixed;
  overflow: hidden;
  transition: right 500ms;
  padding: 25px;
  width: 100%;
  height: 100vh;
  top: 0;
  right: -100%;
  background-color: #fff;
}
.all-table.visible {
  right: 0%;
}
.table td.has-bg-color {
  padding: 0;

  & > div {
    padding: 0.5em 0.75em;
  }
}
.results-container {
  .all-table {
    .b-table .table-wrapper, .b-table .table-wrapper.has-sticky-header {
      height: 85vh;
    }

    .table-container {
      overflow: hidden;
    }

    .cell-flagged-for-inclusion {
      color: darkgreen;
      font-weight: bold;
    }
    .cell-flagged-for-exclusion {
      color: red;
      font-weight: bold;
    }
  }

  .results-buttons {
    height: 140px;

    button {
      display: block;
      margin: 10px auto;
    }
  }

  .dropdown .dropdown-menu .has-link a {
    padding-right: 1rem;
  }

  .working-portfolio {
    height: 85vh;
    overflow-x: hidden;
    overflow-y: scroll;
  }

  .exchange-comparison {
    text-align: left;
    width: 600px;
    padding: 1rem;
    line-height: 1.4rem;

    .fund-name {
      min-height: 4.2rem;
    }

  }
}
</style>
